var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
import i18next from "i18next";
import { computed, makeObservable } from "mobx";
import { lazy, Component, Suspense, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TerriaError from "../../Core/TerriaError";
import { applyTranslationIfExists, TRANSLATE_KEY_PREFIX } from "../../Language/languageHelpers";
import ViewerMode from "../../Models/ViewerMode";
import MapNavigationItemController from "../../ViewModels/MapNavigation/MapNavigationItemController";
import { useViewState } from "../Context";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Loads the given tool component.
 *
 * The prop toolComponent can be an immediate React Component or a promise to
 * module that exports a default React Component. The promise is useful for
 * lazy-loading the tool.
 */
const Tool = props => {
  const {
    getToolComponent,
    params,
    toolName
  } = props;
  const viewState = useViewState();
  const [t] = useTranslation();

  // Track the tool component & props together so that we always
  // pass the right props to the right tool.
  const [toolAndProps, setToolAndProps] = useState(undefined);
  useEffect(() => {
    setToolAndProps([/*#__PURE__*/lazy(() => Promise.resolve(getToolComponent()).then(c => ({
      default: c
    }))), params]);
  }, [getToolComponent, params]);
  let ToolComponent;
  let toolProps;
  if (toolAndProps !== undefined) [ToolComponent, toolProps] = toolAndProps;
  return /*#__PURE__*/_jsx(ToolErrorBoundary, {
    t: t,
    toolName: toolName,
    terria: viewState.terria,
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx("div", {
        children: "Loading..."
      }),
      children: ToolComponent !== undefined ? /*#__PURE__*/_jsx(ToolComponent, _objectSpread(_objectSpread({}, toolProps), {}, {
        viewState: viewState
      })) : null
    })
  });
};
export let ToolButtonController = (_class = class ToolButtonController extends MapNavigationItemController {
  constructor(props) {
    super();
    this.props = props;
    makeObservable(this);
  }
  get glyph() {
    return this.props.icon;
  }
  get viewerMode() {
    return ViewerMode.Cesium;
  }
  get name() {
    return applyTranslationIfExists(this.props.toolName, i18next);
  }

  // TODO: do not use the global i18next instead get i18n from react-i18next
  // @computed
  get title() {
    const buttonState = this.active ? "open" : "closed";
    return applyTranslationIfExists("".concat(TRANSLATE_KEY_PREFIX, "tool.button.").concat(buttonState), i18next, {
      toolName: this.name,
      toolNameLowerCase: this.name.toLowerCase()
    });
  }
  get active() {
    const currentTool = this.props.viewState.currentTool;
    return super.active || currentTool && currentTool.toolName === this.props.toolName || false;
  }
  activate() {
    this.props.viewState.openTool({
      toolName: this.props.toolName,
      getToolComponent: this.props.getToolComponent,
      params: this.props.params
    });
    super.activate();
  }
  deactivate() {
    this.props.viewState.closeTool();
    super.deactivate();
  }
}, _applyDecoratedDescriptor(_class.prototype, "active", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "active"), _class.prototype), _class);
class ToolErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch() {
    const {
      terria,
      toolName,
      t
    } = this.props;
    terria.raiseErrorToUser(new TerriaError({
      title: t("tool.loadingError.title", {
        toolName
      }),
      message: t("tool.loadingError.message")
    }));
    this.setState({
      hasError: true
    });
  }
  render() {
    return this.state.hasError === true ? null : this.props.children;
  }
}
export default Tool;